import React from "react";
import { LucideIcon } from "lucide-react";
import { cn } from "~/lib/utils";
import FillText from "../animation/FillText";

interface GlobalTextTitleH3Props {
  title: string;
  desc?: string;
  center?: boolean;
  margin?: boolean;
  split?: boolean;
  Icon?: LucideIcon; // opsional, icon dinamis
}

export default function GlobalTextTitleH3({
  title,
  desc,
  center = false,
  margin = true,
  split = true,
  Icon,
}: GlobalTextTitleH3Props) {
  const titleArr = title.split(" ");

  const titleClass = cn(
    "font-semibold tracking-tight mx-auto lg:mx-0 w-fit overflow-hidden",
    "text-[clamp(48px,12vw,90px)]", // ukuran baru
    "leading-[clamp(65px,10vw,80px)] lg:leading-[clamp(105px,10vw,80px)]", // agar tidak nabrak
    center ? "text-center" : "text-left lg:text-left"
  );
  const descClass = cn(
    "mt-4 text-base text-gray-600 max-w-[45rem] mx-auto", // default center
    center ? "text-center lg:text-left" : "text-center lg:text-left" // responsive alignment
  );
  return (
    <div className={margin ? "mb-10 lg:mb-48" : ""}>
      <p
        className={cn(
          "text-md uppercase flex gap-2 items-center justify-center mb-8",
          center ? "" : "lg:text-start lg:justify-start"
        )}
      ></p>

      {/* PART 1 (jika split true & ada 2 kata atau lebih) */}
      {split && titleArr.length > 1 && (
        <FillText text={titleArr[0]} className={titleClass} />
      )}

      {/* PART 2 */}
      <FillText
        text={split ? titleArr[titleArr.length > 1 ? 1 : 0] : title}
        className={titleClass}
      />
      <div className="mt-2 h-2 w-16 bg-yellow-400 rounded-full mx-auto block" />
      {desc && <p className={descClass}>{desc}</p>}
    </div>
  );
}
